<template>
  <div class="lamps">
   <!-- <horse-lamps>
     <ul type='none'>
      <li v-for="(item,index) in list" :key="index">{{item}}</li>
    </ul>
   </horse-lamps> -->
   <aliex-swiper :images="list"></aliex-swiper>
  </div>
</template>

<script>
// import HorseLamps from './compontents/horselamps.vue'
import AliexSwiper from "../../compontents/swiper.vue"

export default {
  components: {
    AliexSwiper
  },
  data() {
    return {
      list: ['https://img01.yzcdn.cn/vant/apple-1.jpg',
        'https://img01.yzcdn.cn/vant/apple-2.jpg',]
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../assets/css/variableName";
@import "../../style/mixin";
.lamps {
  width: 100vw;
  padding: torem(15) torem(20);
  height: 500px;
  background: #fff;
  min-height: torem(25);
  box-shadow: torem(1) torem(2) torem(8) #ccc;
  ul{
    // position: absolute;
    display: flex;
    li{
        flex-shrink: 0;
        padding: 0 torem(10);
        line-height: torem(25);
        text-align: center;
        font-size: torem(14);
        vertical-align: middle;
        height: torem(25);
        background: pink;
        border-radius:torem(25) ;
        margin: 0 torem(6);
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/view/purchase/lamps.vue